export default __webpack_public_path__ + "static/media/2930 spice rack B side.59c0a84f.png";